/**
 * Created by M on 2017/8/24.
 */
//
const EXAM_QUESTION_TYPE_LIST = [
  {
    key: "SINGLE",
    value: "SINGLE",
    name: "单选",
    subjectFlag: false
  },
  {
    key: "MULTISELECT",
    value: "MULTISELECT",
    name: "多选",
    subjectFlag: false
  },
  {
    key: "MULTI",
    value: "MULTI",
    name: "不定项",
    subjectFlag: false
  },
  {
    key: "JUDGE",
    value: "JUDGE",
    name: "判断",
    subjectFlag: false
  },
  {
    key: "FILL",
    value: "FILL",
    name: "填空",
    subjectFlag: true
  },
  {
    key: "QUESTION",
    value: "QUESTION",
    name: "问答",
    subjectFlag: true
  },
  {
    key: "PAIXU",
    value: "PAIXU",
    name: "排序",
    subjectFlag: false
  },
  {
    key: "PEIWU",
    value: "PEIWU",
    name: "连线",
    subjectFlag: false
  },
  {
    key: "YUEDU",
    value: "YUEDU",
    name: "阅读理解",
    subjectFlag: true
  }
];

//正常试题
const NATURE_TYPE_NORMAL = 1;
//零时试题
const NATURE_TYPE_TEMPPRARY = 2;
//过期试题
const NATURE_TYPE_OUT = 3;

const SERVER_TYPE = [
  {
    key: "LOCAL",
    name: "本地"
  },
  {
    key: "FTP",
    name: "Ftp"
  },
  {
    key: "QINIU_CLOUD",
    name: "七牛云"
  },
  {
    key: "TENCENT_CLOUD",
    name: "腾讯云"
  },
  {
    key: "ALIYUN_OSS",
    name: "阿里云oss"
  }
];

const COURSEWARE_TYPE = [
  {
    key: "DOC",
    name: "文档"
  },
  {
    key: "VIDEO",
    name: "视频"
  },
  {
    key: "SCORM",
    name: "SCORM课件"
  },
  {
    key: "OTHER",
    name: "其他"
  },
  {
    key: "URL",
    name: "链接"
  }
];

const COURSE_REGIST_STATUS = [
  {
    key: "WAIT_AUDIT",
    name: "待审核",
    buttonText: "待审批",
    type: "primary"
  },
  {
    key: "REFUSE",
    name: "拒绝",
    buttonText: "审批被拒绝,重新申请学习",
    type: "warning"
  },
  {
    key: "UNSTART",
    name: "未开始",
    buttonText: "立即学习",
    type: "success"
  },
  {
    key: "PROCESSING",
    name: "学习中",
    buttonText: "继续学习",
    type: "success"
  },
  {
    key: "WAIT_EXAM",
    name: " 待考试",
    buttonText: "立即考试",
    type: "success"
  },
  {
    key: "EXAM_FAIL",
    name: "考试失败",
    buttonText: "考试失败,重新考试",
    type: "warning"
  },
  {
    key: "WAIT_TAG",
    name: "待标记",
    buttonText: "完成审核中",
    type: "primary"
  },
  {
    key: "EXAM_JUDGING",
    name: "考试评卷中",
    buttonText: "考试评卷中",
    type: "success"
  },
  {
    key: "FINISH",
    name: "已完成",
    buttonText: "已完成",
    type: "success"
  }
];

const COURSE_TYPE = [
  {
    key: "ONLINE",
    name: "在线课程"
  },
  {
    key: "PACKAGE",
    name: "系列课程"
  },
  {
    key: "OFFLINE",
    name: "线下课程"
  },
  {
    key: "TRAIN_ONLINE",
    name: "在线课程"
  },
  {
    key: "TRAIN_OFFLINE",
    name: "线下课程"
  }
];

const TRAIN_COURSE_TYPE = [
  {
    key: "FACE",
    name: "面授课程"
  },
  {
    key: "SELF",
    name: "自学课程"
  },
  {
    key: "OTHDER",
    name: "其他活动"
  }
];

//课件进度
const STUDY_STATUS = [
  {
    key: "",
    name: "未开始"
  },
  {
    key: "NotStarted",
    name: "未开始"
  },
  {
    key: "Processing",
    name: "学习中"
  },
  {
    key: "Completed",
    name: "已完成"
  },
  {
    key: "Fail",
    name: "失败"
  }
];

const PACKAGE_ITEM_TYPE = [
  {
    key: "ONLINE_COURSE",
    name: "线上课程"
  },
  {
    key: "OFFLINE_COURSE",
    name: "线下课程"
  },
  {
    key: "EXAM",
    name: "考试"
  },
  {
    key: "OTHER",
    name: "其他"
  },
  {
    key: "HOMEWORK",
    name: "作业"
  },
  {
    key: "SURVEY",
    name: "调研"
  },
  {
    key: "ASSESSMENT",
    name: "评估"
  }
];

const DICTIONARY_TYPE = [
  {
    key: "NATIONALITY",
    name: "国籍"
  },
  {
    key: "NATION",
    name: "民族"
  },
  {
    key: "EDUCATION",
    name: "学历"
  },
  {
    key: "CREDENTIALS_TYPE",
    name: "证件类型"
  },
  {
    key: "ENGLISH_LEVEL",
    name: "英语等级"
  },
  {
    key: "MENU_CODE",
    name: "菜单编码"
  },
  {
    key: "RANK",
    name: "职等"
  },
  {
    key: "DOC_IMPORTANT",
    name: "关键文档类型"
  },
  {
    key: "DOC_KIND",
    name: "文档分类"
  },
  {
    key: "MSG_MODULE",
    name: "消息模块"
  },
  {
    key: "GRADE_CATEGORY",
    name: "职等类别"
  },
  {
    key: "GRADE_SUB_CATEGORY",
    name: "职等子类别"
  },
  {
    key: "EMPLOY_RELATION_TYPE",
    name: "用工关系类型"
  },
  {
    key: "EMPLOY_RELATION_STATUS",
    name: "用工关系状态"
  },
  {
    key: "JOB_LEVEL",
    name: "职层"
  },
  {
    key: "JOB_RANK",
    name: "职衔"
  },
  {
    key: "JOB_RANK_TABLE",
    name: "职等表"
  },
  {
    key: "TRAIN_FEE_TYPE",
    name: "费用类型"
  },
  {
    key: "COURSE_TYPE",
    name: "课程类别"
  },
  {
    key: "COURSE_LEVEL",
    name: "课程级别"
  },
  {
    key: "TRAIN_TYPE",
    name: "培训类型"
  },
  {
    key: "EVALUATION_STYLE",
    name: "评价方式"
  },
  {
    key: "TRAINING_FORM",
    name: "培训形式"
  },
  {
    key: "TEST_METHOD",
    name: "考核方式"
  },
  {
    key: "EXAM_TYPE",
    name: "考试类型"
  },
  {
    key: "QUALIFIED_STANDARD",
    name: "合格标准"
  },
  {
    key: "CERTIFICATE_TYPE",
    name: "证书类型"
  },
  {
    key: "TRAIN_NEEDS_TYPE",
    name: "培训需求类型"
  },
  {
    key: "RULE_DESCRIPTION_TYPE",
    name: "规则说明"
  },
  {
    key: "POST_TYPE",
    name: "岗位类型"
  },
  {
    key: "OCCUPATION_TYPE",
    name: "职业类型"
  }
];

const DOC_STATUS = [
  {
    key: "PUBLISH",
    name: "已发布"
  },
  {
    key: "UNPUBLISH",
    name: "未发布"
  },
  {
    key: "REFUSED",
    name: "审核拒绝"
  },
  {
    key: "WAIT_AUDIT",
    name: "待审核"
  },
  {
    key: "DISABLE",
    name: "停用"
  }
];

const TV_STATUS = [
  {
    key: "DRAFT",
    name: "草稿"
  },
  {
    key: "STARTING",
    name: "已发布"
  }
];

const COURSE_FINISH_TYPE = [
  {
    key: "AUTO_FINISH",
    name: "自动完成"
  },
  {
    key: "ADMIN_MARK_FINISH",
    name: "管理员标记完成"
  },
  {
    key: "AFTER_COURSE_EXAM_FINISH",
    name: "课后考试完成"
  }
];

//年度计划 -考核方式
const ASSESSMENT_METHOD = [
  {
    key: "ONLINE_TEST",
    name: "网络测试"
  },
  {
    key: "PAPER_TEST",
    name: "书面考试"
  },
  {
    key: "ASK_TEST",
    name: "提问交流"
  },
  {
    key: "OFFLINE_TEST",
    name: "现场实操"
  },
  {
    key: "SIMULATE",
    name: "情景演练"
  },
  {
    key: "DOC_REPORT",
    name: "案例报告"
  },
  {
    key: "SYNTHETIC",
    name: "综合评估"
  },
  {
    key: "OTHER",
    name: "其他"
  }
];

const SURVEY_TEMPLATE_TYPE = [
  {
    key: "ORG_SURVEY",
    name: "组织调研"
  },
  {
    key: "COURSE_SURVEY",
    name: "课程调研"
  },
  {
    key: "COURSE_ASSESS",
    name: "课程评估"
  },
  {
    key: "TEACHER_ASSESS",
    name: "讲师评估"
  },
  {
    key: "ORG_ASSESS",
    name: "组织评估"
  },
  {
    key: "UNITY",
    name: "统一评估"
  }
];

const SEARCH_BUSINESS_TYPE = [
  {
    key: "EXAM",
    name: "考试"
  },
  {
    key: "TRAIN",
    name: "培训"
  },
  {
    key: "DOC",
    name: "文档"
  },
  {
    key: "COURSE",
    name: "课程"
  },
  {
    key: "BBS",
    name: "帖子"
  },
  {
    key: "TEACHER",
    name: "讲师"
  }
];

const WORKFLOW_BUSINESS_TYPE = [
  {
    key: "YearPlan",
    name: "年度计划审批"
  },
  {
    key: "MonthPlan",
    name: "月度计划审批"
  },
  {
    key: "OpenClass",
    name: "培训开班审批"
  },
  {
    key: "EndClass",
    name: "班级结束审批"
  },
  {
    key: "PublishOnlineCourse",
    name: "在线课程发布审批"
  },
  {
    key: "PublishExam",
    name: "考试发布审批"
  },
  {
    key: "PublishLive",
    name: "直播申请审批"
  },
  {
    key: "SignClass",
    name: "班级报名审批"
  },
  {
    key: "SignCourse",
    name: "在线课程学习审批"
  },
  {
    key: "UploadDocument",
    name: "知识上传审批"
  },
  {
    key: "DownloadDocument",
    name: "知识下载审批"
  },
  {
    key: "OutTrainRequest",
    name: "外训申请审批"
  },
  {
    key: "TrainRequest",
    name: "培训需求申请"
  },
  {
    key: "TeacherAudit",
    name: "内训师申请审批"
  },
  {
    key: "TrainNeedsAudit",
    name: "部门需求申请审批"
  },
  {
    key: "MonthPlanChange",
    name: "月度计划变更审批"
  },
  {
    key: "AttendanceLeaveAudit",
    name: "考勤请假审批"
  },
  {
    key: "SysHourCreditIntegralApply",
    name: "课时学分积分申请"
  },
  {
    key: "TrainClassActionPlanSubmit",
    name: "培训班级行动计划申请"
  },
  {
    key: "ClassRoomApply",
    name: "教室申请"
  },
  {
    key: "TeacherPersonAudit",
    name: "个人讲师申请"
  },
  {
    key: "TrainOpenClassApply",
    name: "培训开班申请"
  }
  
];

const JIFENGUIZI_TYPE = [
  {
    key:"THUMBUP",
    name:"课程点赞"
  },
  {
    key: "LOGIN",
    name: "系统登陆"
  },
  {
    key: "ONLINE_CLICK",
    name: "在线点击"
  },
  {
    key: "JOIN_STUDY",
    name: "参与学习"
  },
  {
    key: "JOIN_PROJECT",
    name: "参与班级"
  },
  {
    key: "JOIN_EXAM",
    name: "参与考试"
  },
  {
    key: "SEE_DOC",
    name: "查阅知识"
  },
  {
    key: "JOIN_TV_LIVE",
    name: "参与直播"
  },
  {
    key: "JOIN_SURVEY",
    name: "参与调研"
  },
  {
    key: "PUBLISH_COMMENT",
    name: "发表讨论"
  },
  {
    key: "JOIN_COMMENT",
    name: "参与讨论"
  },
  {
    key: "TEACHING",
    name: "讲师授课"
  },
  {
    key: "UPLOAD_ONLINE_COURSE",
    name: "在线课程(上传课程)"
  },
  {
    key: "TV_LIVE_TEACHING",
    name: "直播授课"
  },
  {
    key: "PROJECT_MANAGER",
    name: "班级管理员"
  },
  {
    key: "INTEGRAL_REWARD",
    name: "积分打赏"
  },
  {
    key: "DOCUMENT_DOWNLOAD",
    name: "文档下载"
  },
  {
    key: "INTEGRAL_EXCHANGE",
    name: "积分兑换"
  },
  {
    key: "OFFER_A_REWARD",
    name: "积分悬赏"
  },
  {
    key: "DOC_UPLOAD",
    name: "文档上传"
  },
  {
    key: "DOCUMENT_DOWNLOAD_ADD",
    name: "文档下载(积分增加)"
  },
  {
    key: "OTHER",
    name: "其他"
  },
  {
    key: "FIRST_LOGIN",
    name: "首次登陆"
  },
  {
    key: "CONTINUE_LOGIN",
    name: "连续登陆"
  },
  {
    key: "PROJECT_FINISH_SIGN",
    name: "完成一次报名"
  },
  {
    key: "SIGN_UP_BUT_UNATTENDANCE",
    name: "报名后未出席培训"
  },
  {
    key: "DAILY_CHECKIN",
    name: "每日签到"
  },
  {
    key: "PROJECT_SIGN_IN",
    name: "完成一次签到"
  },
  {
    key: "COURSE_INFO_RATE",
    name: "给课程评星"
  },
  {
    key: "DOC_UPLOAD_AND_PASS",
    name: "文档上传并通过审核"
  },
  {
    key: "VIDEO_UPLOAD",
    name: "微课视频制作并上传"
  },
  {
    key: "TRIAN_PLAN_SURVEY_TEACHER",
    name: "辅导老师对学员评估"
  }
];

export {
  EXAM_QUESTION_TYPE_LIST,
  NATURE_TYPE_NORMAL,
  NATURE_TYPE_TEMPPRARY,
  NATURE_TYPE_OUT,
  SERVER_TYPE,
  COURSEWARE_TYPE,
  COURSE_REGIST_STATUS,
  STUDY_STATUS,
  COURSE_TYPE,
  PACKAGE_ITEM_TYPE,
  DICTIONARY_TYPE,
  DOC_STATUS,
  COURSE_FINISH_TYPE,
  ASSESSMENT_METHOD,
  TRAIN_COURSE_TYPE,
  SURVEY_TEMPLATE_TYPE,
  SEARCH_BUSINESS_TYPE,
  WORKFLOW_BUSINESS_TYPE,
  TV_STATUS,
  JIFENGUIZI_TYPE
};



// WEBPACK FOOTER //
// ./src/config/BusinessEnums.js